import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Btn } from "@/components/portal/crm/kit";

/** A quiet note at the top of the introducer's workspace: a recruit has put their first case in. */
export function NetworkPing() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try { setItems((await api.get("/refer/network/pings")).data.items || []); }
    catch { setItems([]); }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);

  const seen = async (id) => {
    setItems((prev) => prev.filter((p) => p.id !== id));
    try { await api.post(`/refer/network/pings/${id}/seen`); } catch { /* it will come back on the next poll */ }
  };

  if (!items.length) return null;
  const p = items[0];
  const more = items.length - 1;

  return (
    <div className="ping" data-testid="network-ping">
      <span className="ping-dot" />
      <span className="ping-text" data-testid="network-ping-text">
        <b>{p.recruit_name}</b>{p.level === 2 && p.via ? ` (via ${p.via})` : ""} has put their first case in
        {p.finance_type ? ` — ${p.finance_type.toLowerCase()}, ${p.amount_band}` : ""}. It&apos;s in your network now.
        {more > 0 && <span className="ping-more"> +{more} more</span>}
      </span>
      <span className="ping-actions">
        <Btn kind="primary" sm onClick={() => { seen(p.id); nav("/introducer/network"); }} testId="network-ping-open">See your network</Btn>
        <Btn sm onClick={() => seen(p.id)} testId="network-ping-seen">Got it</Btn>
      </span>
    </div>
  );
}
